module.exports = __webpack_public_path__ + "static/fossa.9ee6706f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/clients/fossa.png
// module id = 476
// module chunks = 35783957827783